import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

import { getDashboardSalesDealer } from "@/api/Dashboard/dashboard";
import Fetching from "@/components/Fetching/Fetching";
import { formatMilesDecimal, formatShortNumber, initialText, validRoles } from "@/services/Utils";

import classes from "./dashboard-sales-dealer.module.scss";

const DashboardSalesDealer = ({ filters }) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola"]);

	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);

	const { data, isLoading } = useQuery(["dashboard_sales_dealer", { ...filters, estate_parent_id, estate_id, type_currency }], () =>
		getDashboardSalesDealer({
			...filters,
			estate_parent_id,
			estate_id,
			type_currency,
		}),
	);

	const [chartData, setChartData] = useState([]);
	const [total, setTotal] = useState(0);

	useEffect(() => {
		if (!data) return;
		let allTotal = 0;
		const transformed = data.map((item) => {
			let label = item.label;
			if (label !== "SIN ASIGNAR" && label.split(" ").length > 1) {
				label = initialText(label);
			}
			allTotal += item.data;
			return { label, value: item.data, fill: item.backgroundColor };
		});
		setChartData(transformed);
		setTotal(allTotal);
	}, [data]);

	if (!isManager) return null;

	return (
		<>
			{isLoading ? (
				<Fetching topMargin="5em" bottomMargin="5em" />
			) : (
				<div className={classes.container}>
					<div className={classes.show_table}>
						<table className={classes.table}>
							<tbody>
								<tr>
									<td className={classes.first_td}>Total de Compras</td>
									<td className={classes.last_td}>${formatMilesDecimal(total)}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className={classes.graph_filter}>
						<ResponsiveContainer width="100%" height="100%">
							<BarChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
								<XAxis dataKey="label" tick={{ fontSize: 12 }} angle={-35} textAnchor="end" interval={0} height={50} />
								<YAxis tickFormatter={formatShortNumber} tick={{ fontSize: 12 }} />
								<CartesianGrid strokeDasharray="3 3" vertical={false} />
								<Tooltip
									content={({ active, payload, label }) => {
										if (active && payload && payload.length) {
											return (
												<div
													style={{
														backgroundColor: "#fff",
														border: "1px solid #ccc",
														padding: "8px",
														borderRadius: "6px",
													}}
												>
													<p
														style={{
															margin: 0,
															fontSize: "13px",
															fontWeight: 500,
															color: "#374151",
														}}
													>
														{label}: ${formatMilesDecimal(payload[0].value)}
													</p>
												</div>
											);
										}
										return null;
									}}
								/>
								<Bar dataKey="value">
									{chartData.map((entry, idx) => (
										<Cell key={idx} fill={entry.fill} />
									))}
								</Bar>
							</BarChart>
						</ResponsiveContainer>
					</div>
				</div>
			)}
		</>
	);
};

export default DashboardSalesDealer;
